import { useContext } from 'react'

import { ShopAndRuntimeConfigContext } from 'views/components/templates/helpers'
import { PageProperties } from 'types/pageProperties'
import { PublicConfig } from 'types/shopConfig'

// Utils are used within FC, so it is fine to use `useContext` here
export const getPublicConfig = (): PublicConfig => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { publicConfig } = useContext(ShopAndRuntimeConfigContext)

  return publicConfig as PublicConfig
}

export const getPageProperties = (): PageProperties => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { pageProperties } = useContext(ShopAndRuntimeConfigContext)

  return pageProperties as PageProperties
}
